export default __webpack_public_path__ + "static/media/personalMark.39d68754.png";